import { render } from "./AttendanceLogModal.vue?vue&type=template&id=ff36ae68"
import script from "./AttendanceLogModal.vue?vue&type=script&lang=js"
export * from "./AttendanceLogModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__